import * as React from "react";
import sfetch from "./commons/utils/super-fetch";
import SettingsForm from "./settings/SettingsForm";
import ToggleButton from "./commons/components/buttons/ToggleButton";
import SmileSimulationTreatmentSettings from "./settings/SmileSimulationTreatmentSettings";
import { useState } from "react";

export interface SmileSimulationSettingsProps {
  settings: SmileSimulationTreatmentSettings;
  updateUrl: string;
}

interface SmileSimulationSettingsState {
  settings: SmileSimulationTreatmentSettings;
  warningMessage?: string;
}

interface TreatmentConfiguration {
  setting: keyof SmileSimulationTreatmentSettings;
  label: string;
}

const treatmentSettingsConfiguration: TreatmentConfiguration[] = [
  {
    setting: "alignersEnabled",
    label: i18n["Page.Settings.Customisation.SmileSimulation.Treatment.Aligners"],
  },
  {
    setting: "metallicBracesEnabled",
    label: i18n["Page.Settings.Customisation.SmileSimulation.Treatment.MetallicBraces"],
  },
  {
    setting: "selfLigatingBracesEnabled",
    label: i18n["Page.Settings.Customisation.SmileSimulation.Treatment.SelfLigatingBraces"],
  },
  {
    setting: "ceramicBracesEnabled",
    label: i18n["Page.Settings.Customisation.SmileSimulation.Treatment.CeramicBraces"],
  },
];

export const SmileSimulationSettingsForm = (props: SmileSimulationSettingsProps) => {
  const [state, setState] = useState<SmileSimulationSettingsState>({
    settings: props.settings,
  });

  const onSettingChanged = (setting: keyof SmileSimulationTreatmentSettings, newValue) => {
    setState({
      settings: {
        ...state.settings,
        [setting]: newValue,
      },
      warningMessage: null,
    });
  };

  const onSave = () => {
    return sfetch(props.updateUrl, {
      method: "PUT",
      body: JSON.stringify(state.settings),
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => document.location.reload());
  };

  const isOnlyOneTreatmentEnabled = (): boolean => {
    return (
      treatmentSettingsConfiguration.filter((it) => isTreatmentEnabled(it.setting)).length == 1
    );
  };

  const hasChanges = (): boolean => {
    return Object.keys(state.settings).some(
      (field) => state.settings[field] !== props.settings[field]
    );
  };

  const isTreatmentEnabled = (setting: keyof SmileSimulationTreatmentSettings): boolean => {
    return state.settings[setting];
  };

  return (
    <SettingsForm
      title={i18n["Page.Settings.Customisation.SmileSimulation.Title"]}
      hasChanges={hasChanges()}
      onSave={onSave}
      actionsOnLeftSide={true}
    >
      <div className="vertical-container">
        {treatmentSettingsConfiguration.map((it) => (
          <ToggleButton
            key={it.setting}
            value={isTreatmentEnabled(it.setting)}
            onChange={(newValue) => onSettingChanged(it.setting, newValue)}
            onChangeDisabled={() =>
              setState({
                ...state,
                warningMessage:
                  i18n["Page.Settings.Customisation.SmileSimulation.Warning.AtLeastOneTreatment"],
              })
            }
            disabled={isTreatmentEnabled(it.setting) && isOnlyOneTreatmentEnabled()}
            label={it.label}
          />
        ))}
        {state.warningMessage && <div className="message warning">{state.warningMessage}</div>}
      </div>
    </SettingsForm>
  );
};
